function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreece(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4166AF"
    },
    d: "M30 22.331c0 1.645 -1.306 2.952 -2.903 2.952H2.903c-1.597 0 -2.903 -1.306 -2.903 -2.952V7.621c0 -1.645 1.306 -2.952 2.903 -2.952h24.194c1.597 0 2.903 1.306 2.903 2.952V22.331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#28559E"
    },
    d: "M2.903 4.669h24.194c1.597 0 2.903 1.306 2.903 2.952v14.71c0 1.645 -1.306 2.952 -2.903 2.952"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0B4182"
    },
    d: "M2.903 4.669h24.194c1.597 0 2.903 1.306 2.903 2.952v5.371"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8E0EA"
    },
    d: "M0.097 23.008C0.387 24.315 1.548 25.282 2.903 25.282h24.194c1.355 0 2.516 -0.968 2.806 -2.274H0.097z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3D2E2"
    },
    d: "M27.629 25.234c0.145 -0.048 0.29 -0.048 0.435 -0.097c0 0 0.048 0 0.048 -0.048c0.145 -0.048 0.29 -0.097 0.387 -0.194l0 0c0.145 -0.097 0.242 -0.145 0.387 -0.242l0 0c0.097 -0.097 0.242 -0.194 0.339 -0.339l0 0c0.29 -0.339 0.532 -0.774 0.677 -1.258H24.435l2.661 2.274c0.145 0 0.29 0 0.435 -0.048C27.581 25.234 27.629 25.234 27.629 25.234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8E0EA"
    },
    d: "M12.629 9.653H30v-2.081c0 -0.097 0 -0.194 0 -0.29H12.629V9.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3D2E2"
    },
    d: "M30 7.331H12.629v0.339l6.629 1.984H30v-2.081C30 7.524 30 7.427 30 7.331z"
  }), /*#__PURE__*/React.createElement("path", {
    x: 208.8,
    y: 207.6,
    style: {
      fill: "#FFFFFF"
    },
    width: 287.2,
    height: 39.2,
    d: "M12.629 12.556H30V14.927H12.629V12.556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8E0EA"
    },
    points: "208.8,214.8 246.4,246.8 496,246.8 496,207.6 208.8,207.6 ",
    d: "M12.629 12.992L14.903 14.927L30 14.927L30 12.556L12.629 12.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    points: "120.8,294 120.8,203.6 208.8,203.6 208.8,164.4 120.8,164.4 120.8,77.2 81.6,77.2  81.6,164.4 0,164.4 0,203.6 81.6,203.6 81.6,294 0,294 0,333.2 496,333.2 496,294 ",
    d: "M7.306 17.782L7.306 12.315L12.629 12.315L12.629 9.944L7.306 9.944L7.306 4.669L4.935 4.669L4.935 9.944L0 9.944L0 12.315L4.935 12.315L4.935 17.782L0 17.782L0 20.153L30 20.153L30 17.782Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8E0EA"
    },
    points: "196,203.6 208.8,203.6 208.8,164.4 150.4,164.4  ",
    d: "M11.855 12.315L12.629 12.315L12.629 9.944L9.097 9.944Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8E0EA"
    },
    points: "120.8,138.8 120.8,77.2 81.6,77.2 81.6,106  ",
    d: "M7.306 8.395L7.306 4.669L4.935 4.669L4.935 6.411Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8E0EA"
    },
    points: "348.8,333.2 496,333.2 496,294 302.4,294  ",
    d: "M21.097 20.153L30 20.153L30 17.782L18.29 17.782Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreece);
export default __webpack_public_path__ + "static/media/Greece.cadaa85034c7313c4ab24ef0e6d280a2.svg";
export { ForwardRef as ReactComponent };